import React from "react"
import styles from "./styles.scss"

class CheckBoxField extends React.Component {
  render() {
    const {
      input: { value, onChange },
    } = this.props

    return (
      <input 
        className={styles.checkBox}
        type="checkbox"
        checked={value}
        onChange={onChange}
      />
    )
  }
}

export default CheckBoxField



// WEBPACK FOOTER //
// src/components/Fields/CheckBoxField/index.jsx